import React, { FC } from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import styles from './styles';

interface IProps extends WithStyles<typeof styles> {
  height?: number | string;
  width?: number | string;
  shape?: 'square' | 'rounded' | 'circle';
}

const Image: FC<IProps> = ({ classes, height, width, shape }) => {
  function getRadius() {
    if (shape === 'rounded') {
      return 4;
    }

    if (shape === 'circle') {
      return '50%';
    }

    return 0;
  }

  const style = {
    borderRadius: getRadius(),
    height,
    width,
  };

  return <div style={style} className={classes.animation} />;
};

Image.defaultProps = {
  height: 20,
  width: 20,
  shape: 'square',
};

export default withStyles(styles)(Image);
